import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { customDialogDriverFactory } from './CustomDialog.driver';
import { CustomDialog, CustomDialogProps } from '.';

const children = <div>Children</div>;

describe('CustomDialog', () => {
  const createDriver = createRendererWithUniDriver(customDialogDriverFactory);

  const bootstrap = (_: Partial<CustomDialogProps> = {}) => {
    return createDriver(<CustomDialog>{children}</CustomDialog>);
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });

  it('expect dialog to be open', async () => {
    const { driver } = createDriver(
      <CustomDialog isOpen>{children}</CustomDialog>,
    );
    expect(await driver.isDialogOpen()).toBe(true);
  });

  it('expect dialog to be closed', async () => {
    const { driver } = createDriver(
      <CustomDialog isOpen={false}>{children}</CustomDialog>,
    );
    expect(await driver.isDialogOpen()).toBe(false);
  });

  it('should render children', async () => {
    const { driver } = createDriver(
      <CustomDialog isOpen>
        <div data-hook="dialog-children">Dialog children</div>
      </CustomDialog>,
    );
    expect(await driver.childExists('[data-hook="dialog-children"]')).toBe(
      true,
    );
  });
});
